<template>
  <div class="content">
    <div class="content-header flexing">
      <h3 id="page-title">
        {{
          $route.params.fromTo
            ? $route.params.fromTo.replace("_", " - ")
            : t.press.printedPublication
        }}
      </h3>
      <!-- search input -->
      <div v-if="!$route.params.id">
        <input type="search" v-model="search" :placeholder="t.listSearch" />
      </div>
    </div>
    <!-- paginate -->
    <div v-show="filteredList.length && !$route.params.id">
      <paginate
        class="content-list"
        ref="press_list"
        name="pressPaginated"
        tag="div"
        :list="filteredList"
        :per="6"
        :refreshCurrentPage="true"
      >
        <!-- item -->
        <PressListId
          v-for="(item, i) in paginated('pressPaginated')"
          :key="i"
          :item="item"
          @start-gallery="startGallery"
        />
      </paginate>
      <paginate-links
        for="pressPaginated"
        :limit="3"
        :show-step-links="true"
        :hide-single-page="true"
      ></paginate-links>
    </div>
    <!-- single view -->
    <div v-if="$route.params.id">
      <PressListId :item="filterPressId" @start-gallery="startGallery" />
    </div>
    <!-- IMAGE VIEWER -->
    <viewer
      :images="imageGallery.galleryItems"
      :options="viewer_options"
      @inited="initedViewer"
    >
      <img
        v-for="src in imageGallery.galleryItems"
        :src="file(src.link)"
        :key="src.id"
        class="extra-image"
      />
    </viewer>
    <!-- IMAGE VIEWER -->
  </div>
</template>

<script>
import PressListId from "../../components/PresListId.vue";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      imageGallery: {
        galleryItems: [],
        totalItems: [],
      },
      selectedItem: {},
      $viewer: undefined,
      search: "",
      paginate: ["pressPaginated"],
    };
  },
  computed: {
    ...mapGetters([
      "t",
      "lng",
      "file",
      "press_list",
      "press_extra_images",
      "imageFixingUrl",
    ]),
    filterPressId() {
      const find = this.press_list.find(
        (item) => item.pressclipping_id == this.$route.params.id
      );
      return find;
    },
    filteredList() {
      return this.press_list
        .filter((item) => {
          // if (this.$route.params.id) {
          //   return item.pressclipping_id == this.$route.params.id;
          // }

          return (
            item.pressclipping_id == this.$route.params.id ||
            item.key.toLocaleLowerCase().indexOf(this.search.toLocaleLowerCase()) > -1
          );
        })
        .sort((a, b) => {
          return new Date(b.pressclipping_date) - new Date(a.pressclipping_date);
        });
    },
    paginateList() {
      return this.paginated("pressPaginated");
    },
    viewer_options() {
      const _ = this;
      const options = {
        async viewed(e) {
          if (
            _.imageGallery.galleryItems.length != _.imageGallery.totalItems.length &&
            e.detail.index > _.imageGallery.galleryItems.length - 4
          ) {
            const nextSplice = _.imageGallery.totalItems.slice(
              _.imageGallery.galleryItems.length,
              _.imageGallery.galleryItems.length + 5
            );
            let timeout = 100;
            await nextSplice.forEach((img) => {
              _.imageGallery.galleryItems.push(img);
            });
          }
        },
        zoomRatio: 0.5,
        toolbar: {
          zoomIn: 1,
          zoomOut: 1,
          oneToOne: 1,
          reset: 1,
          prev: 1,
          next: 1,
        },
      };
      return options;
    },
  },
  watch: {
    paginateList(newValue, oldValue) {
      const array = [];
      newValue.find((item) => {
        const ID = item.pressclipping_id;
        array.push(ID);
      });
      this.$store.dispatch("press_extra_images", array);
    },
  },
  methods: {
    initedViewer(viewer) {
      this.$viewer = viewer;
    },
    startGallery(item) {
      const images = this.filteredFile(
        item.pressclipping_id,
        item.pressclipping_imagelink
      );
      this.imageGallery.totalItems = images;
      this.imageGallery.galleryItems = this.imageGallery.totalItems.slice(0, 10);
      setTimeout(() => {
        this.$viewer.view(0);
      }, 100);
    },

    filteredFile(parentID, coverLink) {
      const findParentImages = this.press_extra_images.find((item) => {
        return item.parent_id == parentID;
      });

      if (findParentImages) {
        const addedCoverImage = [
          {
            id: "",
            link: coverLink,
            name: "",
          },
          ...findParentImages.images,
        ];

        return addedCoverImage;
      }

      return [];
    },
  },
  components: {
    PressListId,
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/colors";
.flexing {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  & > div {
    width: 250px;
    @media screen and (max-width: 480px) {
      width: 100%;
    }
  }
  input {
    margin-top: 20px;
  }
}

.extra-image {
  display: none;
  width: 40px;
  height: 50px;
  margin: 1px;
  border: 1px solid #ccc;
  cursor: pointer;
}
.gallery-button {
  border: 1px solid #4b1b5b;
  border-radius: 2px;
  padding: 3px 5px;
  outline: none;
  cursor: pointer;
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out;
  &:hover {
    background: #4b1b5b;
    color: #fff;
  }
}

.spinner.small {
  margin: 0;
}
</style>
